// extracted by mini-css-extract-plugin
export default {"container":"AddExample_container__LXFVd","modal":"AddExample_modal__SjIyE","title":"AddExample_title__+1htA","btn":"AddExample_btn__y-vu-"};